import FeatureGates from '@atlaskit/feature-gate-js-client';
import { defaultMessageBackend, noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth-starburst/jira-project-space-connected';

import { ProjectPagesSpotlight } from './components/ProjectPagesSpotlight';

export type PlacementContext = {
	title: string;
	description: string;
	flow: string;
	projectId: string;
	onView: () => void;
	onDismiss: () => void;
	active: boolean;
};

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<PlacementContext>(),
		Component: ({ flow, onView, onDismiss, active }: React.PropsWithChildren<PlacementContext>) => {
			const isTestCohort = FeatureGates.getExperimentValue<
				'control' | 'variation' | 'not-enrolled'
			>('grw-1800-auto-connect-space', 'cohort', 'not-enrolled', { fireExperimentExposure: false });

			if (isTestCohort !== 'variation' || !active) return <></>;

			return <ProjectPagesSpotlight flow={flow} onView={onView} onDismiss={onDismiss} />;
		},
	},
});
